export default __webpack_public_path__ + "static/hexagon-c17681badc4a046531d7467c72284eea.svg";